import React, { useEffect, useState } from "react";
import { Modal, Spinner, Table, Badge } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { fetchTaskHistoryById } from "../../../../store/features/task/taskSlice";
import { IoDocumentTextOutline } from "react-icons/io5";
import ReactPaginate from "react-paginate";

const TaskHistoryModal = ({
  selectedTask,
  showTaskHistory,
  setShowTaskHistory,
}) => {
  const { role } = useSelector((state) => state.auth);
  const { taskHistory, loading, taskHistoryPagination } = useSelector(
    (state) => state.tasks
  );
  const { managers, staffs } = useSelector((state) => state.users);
  const [currentPage, setCurrentPage] = useState(0);
  const dispatch = useDispatch();
  const limit = 10;

  useEffect(() => {
    dispatch(
      fetchTaskHistoryById({ taskId: selectedTask.taskId, currentPage, limit })
    );
  }, [selectedTask.taskId, currentPage]);

  return (
    <Modal
      size="lg"
      show={showTaskHistory}
      onHide={() => setShowTaskHistory(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{selectedTask.title} (Histroy)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          {loading ? (
            <Spinner animation="border" />
          ) : (
            <>
              <div className="table-wrapper">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Assigned To</th>
                      <th>Assigned By</th>
                      <th>Completion Notes</th>
                      <th>Accepted</th>
                      {role !== "staff" && <th>Not Accepted Reason</th>}
                      <th>Start date</th>
                      <th>End date</th>
                      <th>Attachments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {taskHistory?.map(({ history }) => (
                      <tr key={history.id}>
                        <td>{history.title}</td>
                        <td>{history.description}</td>
                        <td>
                          {
                            staffs?.find(
                              (staff) => staff._id === history.assignedTo
                            )?.name
                          }
                        </td>
                        <td>
                          {
                            managers?.find(
                              (man) => man._id === history.assignedBy
                            )?.name
                          }
                        </td>
                        <td>{history.completionNotes}</td>
                        <td>
                          {history.approvalStatus !== null && (
                            <Badge
                              bg={
                                history.approvalStatus === "Accepted"
                                  ? "success"
                                  : "danger"
                              }
                            >
                              {history.approvalStatus}
                            </Badge>
                          )}
                        </td>
                        {role !== "staff" && <td>{history.rejectionReason}</td>}

                        <td>
                          {history.startDate &&
                            format(history.startDate, "MM/dd/yyyy")}
                        </td>
                        <td>
                          {history.endDate &&
                            format(history.endDate, "MM/dd/yyyy")}
                        </td>
                        <td>
                          {history.attachments && (
                            <a
                              rel="noreferrer"
                              href={history.attachments}
                              download={true}
                              target="_blank"
                            >
                              {" "}
                              <IoDocumentTextOutline size={"1.2rem"} />
                            </a>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {taskHistoryPagination?.totalPages > 1 && (
                  <div className="d-flex justify-content-center mt-3">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next >"
                      onPageChange={(e) => setCurrentPage(e.selected)}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      pageCount={taskHistoryPagination.totalPages}
                      previousLabel="< Prev"
                      forcePage={currentPage}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </>
      </Modal.Body>
    </Modal>
  );
};

export default TaskHistoryModal;
